/* eslint-disable */
const REACT_APP_LOC_API_URL = 'http://localhost:8085';
const REACT_APP_DEV_API_URL = 'https://jconnect-api.devz.sbs';
const REACT_APP_PROD_API_URL = 'https://jconnect-api.jindapro.com';

export { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, REACT_APP_LOC_API_URL };
